var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserDp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15988",
    "data-name": "Group 15988",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 45.999,
    viewBox: "0 0 44 45.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1700",
    "data-name": "Rectangle 1700",
    width: 44,
    height: 45.999,
    transform: "translate(0 0)",
    fill: "#1abcff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15987",
    "data-name": "Group 15987",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10338",
    "data-name": "Path 10338",
    d: "M39.087,34.729h0L28,31.264V28.123a1.052,1.052,0,0,1,.315-.785,14.91,14.91,0,0,0,4.073-6.506,3.479,3.479,0,0,0,2.442-2.861L35.1,15.99a3.512,3.512,0,0,0-2.1-3.7V9.842A6.464,6.464,0,0,0,27.18,3.418l-1.151-2.3a2.052,2.052,0,0,0-2.492-1l-6.732,2.4A9.374,9.374,0,0,0,11,10.753v1.534a3.51,3.51,0,0,0-2.1,3.7l.275,1.981a3.478,3.478,0,0,0,2.442,2.861,14.908,14.908,0,0,0,4.072,6.506,1.057,1.057,0,0,1,.315.786v3.141L4.913,34.729A6.967,6.967,0,0,0,0,41.41V45a1,1,0,0,0,1,1H43a1,1,0,0,0,1-1V41.41a6.967,6.967,0,0,0-4.913-6.681",
    fill: "#1abcff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDp);
export default __webpack_public_path__ + "static/media/user-dp.ebf38be4c449f825e4e30700a2ef1094.svg";
export { ForwardRef as ReactComponent };